document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".splide-slider");

  if (!slides.length) return;

  slides.forEach((slide) => {
    const splideEl = slide.querySelector(".splide");
    if (!splideEl) return;

    const totalSlide = parseInt(splideEl.getAttribute("data-slides"), 10);
    const disableCarousel = splideEl.getAttribute("data-disable") === "true";
    const splideClass = splideEl.getAttribute("data-class");
    const splideGap = splideEl.getAttribute("data-gap");

    const slideCount = splideEl.querySelectorAll(".splide__slide").length;

    // ✅ DESKTOP rule (unchanged)
    const hasDesktopOverflow = slideCount > totalSlide;

    // ✅ MOBILE rule (FIXED)
    const hasMobileOverflow = slideCount > 1;

    const options = {
      type: "slide",
      perPage: totalSlide,
      perMove: 1,
      gap: `${splideGap}px`,
      pagination: false,
      classes: {
        arrows: "splide__arrows slider-controls",
        arrow: "splide__arrow",
        prev: "splide__arrow--prev prev",
        next: "splide__arrow--next next",
      },
    };

    if (disableCarousel) {
      options.mediaQuery = "min";
      options.breakpoints = {
        1023: {
          destroy: true,
          arrows: false,
        },
        320: {
          type: "loop",
          perPage: 1,
          gap: "16px",
          padding: "20%",
          arrows: hasMobileOverflow === true, // ✅ MOBILE FIX
        },
      };
    } else {
      // ✅ DESKTOP logic (unchanged)
      options.arrows = hasDesktopOverflow;

      options.breakpoints = {
        1024: {
          type: "loop",
          perPage: 1,
          gap: "16px",
          padding: "20%",
          arrows: hasMobileOverflow === true, // ✅ MOBILE FIX
        },
      };
    }

    const splide = new Splide(`.${splideClass}`, options);
    splide.mount();

    // ✅ IMPORTANT: force recalculation on mobile
    splide.refresh();

    // Optional: keep desktop layout clean (unchanged)
    if (!hasDesktopOverflow) {
      splideEl
        .querySelector(".slider-controls")
        ?.classList.add("arrows-disabled");
    }
  });
});
